const handleLink = (data) => {
  if (data.abstractMessage?.staticContent?.formatType === "RichLink") {
    const linkItem = data.abstractMessage.staticContent.linkItem;
    return {
      label: linkItem.titleItem.title,
      url: linkItem.url
    };
  }
  return void 0;
};

export { handleLink };
//# sourceMappingURL=src-utils-miaw-agent-messages-utils.js.map
